import { Box, Typography } from "@mui/material";
import { TextComponent } from "./TextComponent";
import React from "react";
import { PathProvider } from "./PathInfo";

export function VersionNode(props: { componentName: string; value: string }) {
  return (
    <PathProvider currentPath={["__version"]}>
      <Box className="horizontal-flex">
        <Typography>Version: </Typography>
        <TextComponent propName={props.componentName} value={props.value} dontRenderPropName={true} />
      </Box>
    </PathProvider>
  );
}
